<template>
  <div>
    <vue-editor 
    v-model='content' 
    style='height:600px;'
    useCustomImageHandler
    @image-added="handleImageAdded"
    :editorOptions="editorSettings"
    ></vue-editor>
  </div>
</template>

<style>
.editor-row {
  position: fixed;
  text-align:right;
  margin-right: 50px!important;
  margin-bottom: 5px!important;
  bottom: 0;
  right: 0;
  z-index: 1000;
}
</style>
<script>
/* eslint-disable */
import api from '@/api'
import utils from '../../utils';
import campaignAPIs from '../views/Campaign/campaignAPIs'
import { VueEditor, Quill } from 'vue2-editor'
// import ImageResize from 'quill-image-resize-module'
import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from '../../components/views/Campaign/custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// // Quill.register('modules/imageResize', ImageResize)
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)

export default {
  name: 'Vue2Editor',
  props: ['content', 'editorOpened'],
  components: {
    VueEditor
  },
  data() {
    return {              
      editorData: {},
      loader: null,
      loading: false,
      editorSettings: {
        modules: {
          toolbar: {
            container: [
              [{'size': ['small', false, 'large']}],
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image']
            ]
          }
        },
      },
      // editorSettings: {
      //   modules: {
      //     imageResize: {
      //       displaySize: true
      //     }
      //   }
      // }
    }
  },
  watch: {
    content: {
      handler: function(val, oval) {
        if (this.editorOpened) {
          this.$emit('changeEditorOpened')
          return;
        }
        this.$emit('contentChanged', val)
      },
      deep: true
    }, 
  },   
  mounted() {  
      setTimeout(function() {
        pdfMake.fonts = {
          Arial: {
            normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
            bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
          }
        }
      }, 1000);
    },
  methods: {
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      // An example of using FormData
      // NOTE: Your key could be different such as:
      // formData.append('file', file)
      console.log('image added')
      this.$emit('loadingDialogOpen')
      var formData = new FormData();
      formData.append("image", file);
      campaignAPIs
        .uploadEditorImage(formData)
        .then(response => {
          this.$emit('loadingDialogClose')
          if (response) {
            const url = utils.func.constructImageURL(response.url); // Get url from response
            Editor.insertEmbed(cursorLocation, 'image', url);
            resetUploader();
          }
        })
      .catch(error => {
        this.$emit('loadingDialogClose')
        // Request failed.
        console.log('error', error);
        this.$swal({
          text: error,
          type: 'error'
        });
      });
    }
    // editorFocus() {
    //   this.$emit('contentChangeFocus')
    // }
  }
}
</script>


// WEBPACK FOOTER //
// vue2Editor.vue?2c2bc74e